import { Component, Input } from '@angular/core';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'ola-faq',
  template: require('./faq.component.html'),
  styles: [require('./faq.component.scss')]
})
export class FaqComponent {
  @Input() reset;

  constructor(
    flowManager: FlowManagerService,
    modal: ModalService
  ) {
    this.flowManager = flowManager;
    this.modal = modal;
    this.subscription = this.flowManager.faqCopyChange.subscribe(event => {
      if (event) {
        this.faqList = event;
      }
    });
  }

  ngOnChanges(changes) {
    if (changes.reset && changes.reset.currentValue) {
      this.faq = -1;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  action(actionType) {
    switch (actionType) {
      case 'interstitial':
        this.modal.interstitial('sipc_1');
        break;
      default: console.log('Default switch touched', actionType);
        break;
    }
  }
}
